import React from 'react';
import { FinishNewsletterPopup } from '@husky-x/cc-finish-newsletter-popup';
import { CustomComponentsProvider } from '@husky-x/gatsby-theme-husky';
import { FinishNewsletterImageForm } from '@phx-husky/cc-finish-newsletter-image-form';
import { FinishProductDifferences } from '@phx-husky/cc-finish-product-differences';
import { FinishProductsCards } from '@phx-husky/cc-finish-products-cards';

import {
  FinishExploreOurProductsMock,
  FinishNewsletterPopupMock,
  FinishProductCardsMock,
  FinishProductCardsMockUA,
  FinishProductDifferencesMock,
  FinishProductDifferencesMockUA,
} from './custom-components-mocks';
import CustomProductVariants from './src/@husky-x/gatsby-theme-husky/components/CustomProductVariants/CustomProductVariants';
import FinishExploreOurProducts from './src/@husky-x/gatsby-theme-husky/components/FinishExploreOurProducts';

export const wrapRootElement = ({ element }) => (
  <CustomComponentsProvider
    list={[
      {
        key: 'FinishProductDifferences',
        component: () => <FinishProductDifferences {...FinishProductDifferencesMock} />,
      },
      {
        key: 'FinishProductDifferencesUA',
        component: () => <FinishProductDifferences {...FinishProductDifferencesMockUA} />,
      },
      {
        key: 'FinishProductCards',
        // @ts-expect-error - cardsStyle in ProdCards is coded as set of specified strings - mocks provides those strings, but guardtypes them as 'string'
        component: () => <FinishProductsCards {...FinishProductCardsMock} />,
      },
      {
        key: 'FinishProductCardsUA',
        // @ts-expect-error - cardsStyle in ProdCards is coded as set of specified strings - mocks provides those strings, but guardtypes them as 'string'
        component: () => <FinishProductsCards {...FinishProductCardsMockUA} />,
      },
      {
        key: 'FinishNewsletterPopup',
        component: () => <FinishNewsletterPopup {...FinishNewsletterPopupMock} />,
      },
      {
        key: 'custom_finish_newsletter_image_form',
        component: FinishNewsletterImageForm,
      },
      {
        key: 'CustomProductVariants',
        component: CustomProductVariants,
      },
      {
        key: 'FinishExploreOurProducts',
        component: () => <FinishExploreOurProducts {...FinishExploreOurProductsMock} />,
      },
    ]}
  >
    {element}
  </CustomComponentsProvider>
);
